/**
 * La lecture de Mes élèves, celle de `MyStudentsTabScreen.js` : `getStudents` (`GET api/students`) à
 * chaque focus de l'onglet, et au toucher de la flèche « Relire » ou au tirer (patron A : la liste va
 * dans `currentUser.object.students`, le view-model la lit).
 */
import { useFocusEffect } from "@react-navigation/native"
import { useCallback } from "react"
import { useDispatch } from "react-redux"

import { apiRequest } from "../../../../../../data/redux/actions/api"
import { studentsService } from "../../../../../../data/services/studentsService"

export function useTutorStudentsData() {
    const dispatch = useDispatch()
    const refresh = useCallback(() => {
        dispatch(apiRequest(studentsService.getStudents) as never)
    }, [dispatch])
    useFocusEffect(refresh)
    return { refresh }
}
